module.exports = __webpack_public_path__ + "static/media/Sayu.982542a6.png";